import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import TaskIcon from "../../Commands/TaskIcon/TaskIcon";
import FormIcon from "../../Commands/FormIcon/FormIcon";
import DropDownListNew from "../../DropDownList/DropDownListNew";

export default function  Process (props) {
  
  return (
    <React.Fragment>
      <div style = {{  marginRight:"5px", marginTop:"5px"}} onClick ={() => props.onClickProcessIcon()} >
        <ExpandCommand isShow={!props.isExpanded} color = {"skyblue"}  />
        <CollapseCommand isShow={props.isExpanded} color = "skyblue" isStandard={false} />
      </div>
      {!props.isExpanded ? 
        <div style = {{display:"flex", marginLeft:"auto", marginRight:"auto",  width:"1020px", padding:"0 10px 10px 10px"
        , borderRadius: "4px", marginTop:"0px", backgroundColor: "white" }}>
          <div style = {{  marginTop:"11px", marginRight:"10px"}}>
            <FormIcon />
          </div>
          <span style = {{  marginTop:"7px"}}>Demande  hgfghftrtyrtyrtyr</span>
        </div>
      
      : <div style = {{  marginRight:"5px", marginTop:"10px",  minWidth:"195px",  maxWidth:"195px", borderRadius: "4px"}}>
        <div style = {{  lineHeight:"15px", marginRight:"5px",  minWidth:"160px",  maxWidth:"160px"
          , padding: "10px"
          , minHeight: "80px"
          , border: "1px solid lightGray" ,flex:1, flexDirection:'row'
          , backgroundColor: "white" 
          , borderLeft:"2px solid skyblue"}}>
          <span style = {{  fontSize:"12px", fontFamily:"segoe UI"}} >
            <div style = {{  marginTop:"2px",marginRight:"5px", float: "left"}}>
              <FormIcon />
            </div>
            Demande  hgfghftrtyrtyrtyr
          </span>   
          <div style = {{  fontSize:"12px", fontFamily:"segoe UI", marginTop: "15px", marginBottom: "15px"}}>Verification Indentite</div> 
          <div style = {{  fontSize:"12px", fontFamily:"segoe UI"}}>Anselme TCHIAKPE</div>
        </div>
      </div>}
    </React.Fragment>
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/